import { FC, useEffect } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import firebase from 'firebase/compat/app'
import { Spinner } from '../../components'
import { ROUTES, useUser } from '../../utils'
import { StyledConnectView } from '.'

const ConnectView: FC = () => {
  const location = useLocation()
  const history = useHistory()
  const { user, load } = useUser()

  const loginAsUser = async () => {
    try {
      const urlParams = new URLSearchParams(location.search)
      const { token, redirect, sso_check } = Object.fromEntries(urlParams)

      if (!!user?.id && redirect) {
        return (window.location.href = decodeURIComponent(redirect))
      }

      if (!!user?.id) {
        return history.push(ROUTES.home)
      }

      if (sso_check) {
        return window.parent.postMessage('not-authenticated', '*')
      }

      if (!token) {
        throw new Error('Invalid authentication token')
      }

      await firebase.auth().signInWithCustomToken(token)
      await load()

      if (redirect) {
        return (window.location.href = decodeURIComponent(redirect))
      }

      history.push(ROUTES.home)
    } catch (err) {
      console.error(err)
      alert((err as any)?.message || err)
    }
  }

  useEffect(() => {
    loginAsUser()
  }, [location.search, location.state])

  return (
    <StyledConnectView>
      <div className="label">
        <Spinner /> Logging in...
      </div>
    </StyledConnectView>
  )
}

export default ConnectView
